import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getInerval = (period: string, isNFT?: boolean) => {
  if ((period === '24H' || period === '1D' || period === '7D') && isNFT) {
    return '10min'
  }
  if (isNFT) {
    return '1day'
  }
  if (period === '5Y') {
    return '1week'
  }
  if (period === '1D' || period === '24H') {
    return '5min'
  }
  if (period === '1W' || period === '7D' || period === '1M') {
    return '30min'
  }
  if (['14D'].includes(period)) {
    return '10min'
  }

  return '1day'
}
const hasAvailableHours = (datetime: string) => !datetime.includes('T00')
&& !datetime.includes('T01')
&& !datetime.includes('T02')
&& !datetime.includes('T03')
&& !datetime.includes('T04')
&& !datetime.includes('T05')
&& !datetime.includes('T06')

const getAssetEventsLength = async (
  asset: number | string,
  period: string,
  isNFT?: boolean,
) => {
  const { data, error } = await supabase
    .from('asset_time_series')
    .select('*')
    .eq('asset_id', asset)
    .eq('interval', getInerval(period, isNFT))
    .gte('datetime', '2023-09-14T01:55:00+0600')
    .lte('datetime', '2023-09-15T23:59:59+0600')

  if (error) {
    throw new Error(error.message)
  }

  const todayAssetEvents = data
    ?.filter((el) => {
      if (el.datetime.includes('2023-09-14')
      && hasAvailableHours(el.datetime)) {
        return true
      }
      return false
    })

  return todayAssetEvents
}

export default function useAssetEventsLength(
  asset: number | string,
  period: string,
  isNFT?: boolean,
) {
  return useQuery({
    queryKey: ['useAssetEventsLength', asset, period, isNFT],
    queryFn: () => getAssetEventsLength(asset, period, isNFT),
    enabled: Boolean(asset),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
